/**
 * car-sprite-variant.ts — which car sheet a map marker renders (PLA-278).
 *
 * Pure, framework-free policy shared by every SmoothCarMarker placement so the
 * truth table lives in exactly one place (never inlined at the call sites).
 *
 * ## Truth table (mirrors the production 2D map exactly)
 *
 * - Phase 3 outbound (driver NOT returning) -> "hdp"  (the HDP transporter en
 *   route to collect the car).
 * - Phase 3 return  (driver returning)      -> "customer".
 * - Phase 4 / 5 / 6                          -> "customer" (always — the car is
 *   the customer's, being inspected / on the return leg / delivered).
 * - Phase 2 pickup placeholder               -> "customer" (the customer's
 *   parked car, single-order map only).
 *
 * One-line rule: HDP ONLY when the driver is outbound on phase 3; the customer
 * car everywhere else a car appears (phases 1 and 7 show no car at all, so the
 * variant is irrelevant there and defaults to "customer").
 */
import type { SpriteVariant } from "@/components/smooth-car-sprite"

export type { SpriteVariant }

/**
 * Resolves the sprite variant for a car marker from its order phase and leg.
 *
 * @param phase numeric orderPhase (1..7)
 * @param isReturn true when the driver is on the return leg (phase 3 only); for
 *   phases where the leg is irrelevant (2, 4, 5, 6) pass false — the result is
 *   "customer" regardless.
 */
export function carSpriteVariant(phase: number, isReturn: boolean): SpriteVariant {
  return phase === 3 && !isReturn ? "hdp" : "customer"
}
